import {InsideOfChest} from '@fantasmagames/prototype/src/reels/ServerAvalancheReelsRound';

export class ServerCheats {
	private _isCheatsEnabled: boolean;
	private _cheatPositions: number[] = [];
	private _firstThreeReelsCombination: number[];
	private _secondThreeReelsCombination: number[];
	private _shouldTriggerFreeSpins: boolean;
	private _shouldAddChest: boolean;
	private _chestContent: InsideOfChest;
	private _expandedWildReels: number[];
	private _shouldTriggerBattleFreeSpins: boolean;
	private _shouldNOTWinMimicFS: boolean;

	public reset(): void {
		this._isCheatsEnabled = false;
		this._cheatPositions = [];
		this._firstThreeReelsCombination = [];
		this._secondThreeReelsCombination = [];
		this._expandedWildReels = [];
		this._shouldTriggerFreeSpins = false;
		this._shouldAddChest = false;
		this._chestContent = {hasExplotion: false, hasRespin: false, hasExpandedWild: false, hasMimicFreeSpins: false};
		this._shouldTriggerBattleFreeSpins = false;
		this._shouldNOTWinMimicFS = false;
	}

	public get cheatPositions(): number[] {
		return this._cheatPositions;
	}

	public set cheatPositions(value: number[]) {
		this._cheatPositions = value;
	}

	public get firstThreeReelsCombination(): number[] {
		return this._firstThreeReelsCombination;
	}

	public set firstThreeReelsCombination(value: number[]) {
		this._firstThreeReelsCombination = value;
	}

	public get secondThreeReelsCombination(): number[] {
		return this._secondThreeReelsCombination;
	}

	public set secondThreeReelsCombination(value: number[]) {
		this._secondThreeReelsCombination = value;
	}

	public get shouldTriggerFreeSpins(): boolean {
		return this._shouldTriggerFreeSpins;
	}

	public set shouldTriggerFreeSpins(value: boolean) {
		this._shouldTriggerFreeSpins = value;
	}

	public get shouldAddChest(): boolean {
		return this._shouldAddChest;
	}

	public set shouldAddChest(value: boolean) {
		this._shouldAddChest = value;
	}

	public get chestContent(): InsideOfChest {
		return this._chestContent;
	}

	public set chestContent(value: InsideOfChest) {
		this._chestContent = value;
	}

	public get isCheatsEnabled(): boolean {
		return this._isCheatsEnabled;
	}

	public set isCheatsEnabled(value: boolean) {
		this._isCheatsEnabled = value;
	}

	public set expandedWildReels(value: number[]) {
		this._expandedWildReels = value;
	}

	public get expandedWildReels(): number[] {
		return this._expandedWildReels;
	}

	public get shouldTriggerBattleFreeSpins(): boolean {
		return this._shouldTriggerBattleFreeSpins;
	}

	public set shouldTriggerBattleFreeSpins(value: boolean) {
		this._shouldTriggerBattleFreeSpins = value;
	}

	public get shouldNOTWinMimicFS(): boolean {
		return this._shouldNOTWinMimicFS;
	}

	public set shouldNOTWinMimicFS(value: boolean) {
		this._shouldNOTWinMimicFS = value;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/cheats/ServerCheats.ts